<template>
  <div class="SseNotification">
    <template v-for="item in sseData">
      <div
        v-if="
          (item.path != $route.name && item.message.done == 1) ||
          item.message.code == 2
        "
        :key="item.path"
        class="taskItem"
      >
        <div class="notification">
          <span>{{ item.taskName }}任务</span>
          <span v-if="item.message.done == 0">{{ item.message.content }}</span>
          <span v-else>
            {{ item.message.code == 1 ? "已完成" : item.message.content }}
          </span>
          <div @click="lookInfo(item.path)" class="lookBtn">
            去查看
            <i class="el-icon-arrow-right"></i>
          </div>
          <i @click="remove(item.path)" class="el-icon-close"></i>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["sseData"]),
  },
  mounted() {},
  methods: {
    // 去查看
    lookInfo(path) {
      this.$router.push({ name: path, params: { sse: true } });
    },
    // 删除当前提示任务
    remove(path) {
      this.$store.commit("DEL_SSE_MESSAGE", path);
    },
  },
};
</script>
<style lang="scss">
.SseNotification {
  position: fixed;
  z-index: 1000;
  top: 78px;
  right: 35px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .taskItem {
    border-radius: 10px;
    padding: 1px;
    background: linear-gradient(
      139deg,
      rgba(10, 158, 253, 1),
      rgba(40, 88, 248, 1)
    );
    margin-bottom: 20px;
    .notification {
      padding: 11px 9px 11px 16px;
      border-radius: 8px;
      background-color: #fff;
      display: flex;
      align-items: center;
      .lookBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 24px;
        line-height: 24px;
        background: linear-gradient(107deg, #2858f8 0%, #00b7ff 100%);
        border-radius: 12px;
        font-size: 12px;
        color: #fff;
        margin: 0 4px 0 17px;
        padding: 0 10px;
        cursor: pointer;
        user-select: none;
        &:active {
          opacity: 0.75;
        }
      }
      .el-icon-close {
        font-size: 18px;
        color: #666;
        cursor: pointer;
      }
    }
  }
}
</style>
